class ZimmaLoadMore extends HTMLElement {
  connectedCallback() {
    this.nextUrl = this.dataset.nextUrl || '';
    this.nav = this.querySelector('.pagination-wrapper');
    this.action = this.querySelector('.zimma-load-more__action');
    this.button = this.querySelector('.zimma-load-more__button');
    this.spinner = this.querySelector('.loading__spinner');

    if (!this.nextUrl || !this.action || !this.button) return;

    if (this.nav) this.nav.setAttribute('hidden', '');
    this.action.removeAttribute('hidden');

    this.onClick = () => this.loadNext();
    this.button.addEventListener('click', this.onClick);

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) this.loadNext();
      },
      { rootMargin: '600px 0px' }
    );
    this.observer.observe(this.action);
  }

  // Keeps sold-out cards pushed to the very end across ALL loaded pages combined, not just
  // within the page that was just appended. Mirrors the server-side "stokta olanlar önce"
  // rule (main-collection-product-grid.liquid), which only sees one page at a time — and,
  // like that rule, backs off once the shopper has picked an explicit sort order.
  sinkSoldOut(grid) {
    if (new URLSearchParams(window.location.search).get('sort_by')) return;

    const items = Array.from(grid.children);
    const available = [];
    const soldOut = [];
    items.forEach((item) => {
      (item.querySelector('.zimma-product-card__soldout') ? soldOut : available).push(item);
    });

    const reordered = available.concat(soldOut);
    const orderChanged = reordered.some((item, index) => item !== items[index]);
    if (orderChanged) {
      const fragment = document.createDocumentFragment();
      reordered.forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
  }

  async loadNext() {
    if (!this.nextUrl || this.loading) return;
    this.loading = true;
    this.classList.add('is-loading');
    this.button.disabled = true;
    if (this.spinner) this.spinner.classList.remove('hidden');

    try {
      const response = await fetch(this.nextUrl);
      if (!response.ok) throw new Error('Zimma load-more request failed');
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = doc.getElementById('product-grid');
      const currentGrid = document.getElementById('product-grid');
      if (newGrid && currentGrid) {
        currentGrid.append(...Array.from(newGrid.children));
        this.sinkSoldOut(currentGrid);
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(currentGrid);
        }
      }

      const newLoadMore = doc.querySelector('zimma-load-more');
      this.nextUrl = newLoadMore ? newLoadMore.dataset.nextUrl || '' : '';

      if (!this.nextUrl) {
        if (this.observer) this.observer.disconnect();
        this.remove();
        return;
      }
    } catch (error) {
      // Keep the button enabled so the shopper can retry.
    } finally {
      this.loading = false;
      this.classList.remove('is-loading');
      if (this.isConnected) {
        this.button.disabled = false;
        if (this.spinner) this.spinner.classList.add('hidden');
      }
    }
  }
}

if (!customElements.get('zimma-load-more')) {
  customElements.define('zimma-load-more', ZimmaLoadMore);
}
